import React, {useEffect, useState} from 'react';
import {HStack, VStack} from "native-base";
import AppText from "../../../../../../common/AppText";
import {GlobalStyleAttributes} from "../../../../../../../styles/GlobalStyles";
import {t} from "../../../../../../../services/i18n";
import CustomSwitch from "../../../../../../common/CustomSwitch";
import {isMobile} from "../../../../../../../services/Helpers";
import {toggleScheduleLoader, toggleSuccessFlag} from "../../../../../../../redux/ScheduleSlice";
import {APPOINTMENT_HOVER_CARD} from "../../../../../../../services/ConstHelper";
import {fetchApi} from "../../../../../../../services/HTTP";
import {updateBox} from "../../../../../../../redux/boxSlice";
import {store} from "../../../../../../../redux/store";
import {useDispatch, useSelector} from "react-redux";

const HoverCardSetting = (props) => {
    const {values, setFieldValue} = props
    const shouldSave = useSelector((state) => state.schedule.settingsSaveFlag);
    const dispatch = useDispatch()

    useEffect(() => {
        if(shouldSave) {
            save()
        }
    }, [shouldSave]);

    const toggle = async (val) => {
        try {
            setFieldValue('appointmentHoverCard', val)
        } catch(error) {
            console.log('error',error)
            dispatch(toggleScheduleLoader(false));
        }
    }

    const save = async () => {
        if (isMobile) {
            dispatch(toggleScheduleLoader(true));
            const setting = {prop_name: APPOINTMENT_HOVER_CARD, properties: {active: values.appointmentHoverCard}}
            const res = await fetchApi(`boxes/settings`, 'POST', setting, false, true);
            dispatch(toggleScheduleLoader(false));
            dispatch(toggleSuccessFlag(true))
            dispatch(updateBox({
                settings: {
                    ...store.getState().box.box.settings,
                    [APPOINTMENT_HOVER_CARD]: setting.properties
                }
            }))
        }
    }

    return (
        <VStack space={'0.5rem'}>
            <HStack justifyContent={'space-between'} alignItems={'center'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('showAppointmentHoverCard')}</AppText>
                <CustomSwitch isChecked={values?.appointmentHoverCard} onToggle={toggle}/>
            </HStack>
            <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('showAppointmentHoverCardTxt')}</AppText>
        </VStack>


    )
};

export default HoverCardSetting;